import { render, staticRenderFns } from "./VirtualStops.vue?vue&type=template&id=d4cd70e4"
import script from "./VirtualStops.vue?vue&type=script&lang=js"
export * from "./VirtualStops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports